<template>
  <div class="microlearning-video-actions-bar">
    <div class="microlearning-video-actions-bar-left">
      <button
        v-if="!hasInstructions && showSuggestInstructionsButton"
        class="suggest-instructions-btn"
        :class="{ 'suggest-instructions-btn--hover': isHovered }"
        :disabled="disabled"
        @click="handleSuggestInstructions"
        @mouseenter="isHovered = true"
        @mouseleave="isHovered = false"
      >
        <span class="iq-icon">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="20" height="20" rx="3.75" fill="#ED2738" />
            <path
              d="M16.1392 9.68748C16.1392 10.8551 15.77 11.8681 15.0317 12.7266L15.9589 13.6924L14.6969 14.8128L13.7182 13.7955C13.0228 14.1818 12.2673 14.375 11.4517 14.375C10.1553 14.375 9.05216 13.9242 8.14214 13.0228C7.23211 12.1128 6.7771 11.001 6.7771 9.68748C6.7771 8.37396 7.23211 7.26648 8.14214 6.36504C9.05216 5.45501 10.1553 5 11.4517 5C12.7481 5 13.8512 5.45501 14.7613 6.36504C15.6799 7.26648 16.1392 8.37396 16.1392 9.68748ZM11.4517 12.6365C11.7865 12.6365 12.1213 12.5807 12.4562 12.4691L10.9752 10.9237L12.2372 9.80338L13.8212 11.4517C14.1818 10.9366 14.3621 10.3485 14.3621 9.68748C14.3621 8.82897 14.083 8.1207 13.525 7.56266C12.967 7.00463 12.2759 6.72561 11.4517 6.72561C10.6275 6.72561 9.93643 7.00463 9.37839 7.56266C8.82036 8.1207 8.54134 8.82897 8.54134 9.68748C8.54134 10.5374 8.82036 11.2414 9.37839 11.7994C9.93643 12.3575 10.6275 12.6365 11.4517 12.6365Z"
              fill="white"
            />
            <path
              d="M3.75 5.17969H5.52712V14.1941H3.75V5.17969Z"
              fill="white"
            />
          </svg>
        </span>
        <span class="sparkle-icon">
          <svg
            width="12"
            height="12"
            viewBox="0 0 16 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.57223 7.80932C8.70973 7.39682 9.29223 7.39682 9.42973 7.80932L10.236 10.2306C10.4134 10.7628 10.7124 11.2464 11.1093 11.643C11.5061 12.0397 11.9899 12.3384 12.5222 12.5156L14.9422 13.3218C15.3547 13.4593 15.3547 14.0418 14.9422 14.1793L12.521 14.9856C11.9887 15.163 11.5051 15.462 11.1085 15.8589C10.7119 16.2557 10.4132 16.7395 10.236 17.2718L9.42973 19.6918C9.40009 19.7821 9.34267 19.8608 9.26568 19.9166C9.18869 19.9723 9.09605 20.0024 9.00098 20.0024C8.90592 20.0024 8.81328 19.9723 8.73629 19.9166C8.65929 19.8608 8.60188 19.7821 8.57223 19.6918L7.76598 17.2706C7.58864 16.7385 7.28983 16.2549 6.89322 15.8583C6.49662 15.4617 6.0131 15.1629 5.48098 14.9856L3.05973 14.1793C2.96941 14.1497 2.89075 14.0923 2.83499 14.0153C2.77922 13.9383 2.74920 13.8456 2.74920 13.7506C2.74920 13.6555 2.77922 13.5629 2.83499 13.4859C2.89075 13.4089 2.96941 13.3515 3.05973 13.3218L5.48098 12.5156C6.0131 12.3382 6.49662 12.0394 6.89322 11.6428C7.28983 11.2462 7.58864 10.7627 7.76598 10.2306L8.57223 7.80932ZM3.74348 1.43557C3.76141 1.38144 3.79594 1.33433 3.84216 1.30094C3.88839 1.26756 3.94396 1.24959 4.00098 1.24959C4.05801 1.24959 4.11358 1.26756 4.15980 1.30094C4.20603 1.33433 4.24056 1.38144 4.25848 1.43557L4.74223 2.88807C4.95848 3.53557 5.46598 4.04307 6.11348 4.25932L7.56598 4.74307C7.62012 4.76099 7.66722 4.79552 7.70061 4.84175C7.73400 4.88798 7.75197 4.94355 7.75197 5.00057C7.75197 5.05759 7.73400 5.11316 7.70061 5.15939C7.66722 5.20562 7.62012 5.24015 7.56598 5.25807L6.11348 5.74182C5.79395 5.84787 5.50359 6.02706 5.26553 6.26512C5.02747 6.50318 4.84828 6.79354 4.74223 7.11307L4.25848 8.56557C4.24056 8.61970 4.20603 8.66681 4.15980 8.70020C4.11358 8.73358 4.05801 8.75155 4.00098 8.75155C3.94396 8.75155 3.88839 8.73358 3.84216 8.70020C3.79594 8.66681 3.76141 8.61970 3.74348 8.56557L3.25973 7.11307C3.15369 6.79354 2.97450 6.50318 2.73643 6.26512C2.49837 6.02706 2.20802 5.84787 1.88848 5.74182L0.435984 5.25807C0.381852 5.24015 0.334745 5.20562 0.301358 5.15939C0.267970 5.11316 0.250000 5.05759 0.250000 5.00057C0.250000 4.94355 0.267970 4.88798 0.301358 4.84175C0.334745 4.79552 0.381852 4.76099 0.435984 4.74307L1.88848 4.25932C2.20802 4.15327 2.49837 3.97408 2.73643 3.73602C2.97450 3.49796 3.15369 3.20760 3.25973 2.88807L3.74348 1.43557ZM12.5797 0.12432C12.5921 0.0887276 12.6152 0.0578646 12.6459 0.0360217C12.6766 0.0141788 12.7133 0.00244141 12.751 0.00244141C12.7887 0.00244141 12.8254 0.0141788 12.8561 0.0360217C12.8868 0.0578646 12.9099 0.0887276 12.9222 0.12432L13.2447 1.09182C13.3885 1.52432 13.7272 1.86307 14.1597 2.00682L15.1272 2.32932C15.1628 2.34166 15.1937 2.36478 15.2155 2.39547C15.2374 2.42616 15.2491 2.46290 15.2491 2.50057C15.2491 2.53824 15.2374 2.57498 15.2155 2.60567C15.1937 2.63636 15.1628 2.65948 15.1272 2.67182L14.1597 2.99432C13.9468 3.06557 13.7533 3.18531 13.5945 3.34409C13.4357 3.50287 13.316 3.69637 13.2447 3.90932L12.9222 4.87682C12.9099 4.91241 12.8868 4.94328 12.8561 4.96512C12.8254 4.98696 12.7887 4.99870 12.751 4.99870C12.7133 4.99870 12.6766 4.98696 12.6459 4.96512C12.6152 4.94328 12.5921 4.91241 12.5797 4.87682L12.2572 3.90932C12.186 3.69637 12.0662 3.50287 11.9075 3.34409C11.7487 3.18531 11.5552 3.06557 11.3422 2.99432L10.376 2.67182C10.3404 2.65948 10.3095 2.63636 10.2877 2.60567C10.2658 2.57498 10.2541 2.53824 10.2541 2.50057C10.2541 2.46290 10.2658 2.42616 10.2877 2.39547C10.3095 2.36478 10.3404 2.34166 10.376 2.32932L11.3435 2.00682C11.776 1.86307 12.1147 1.52432 12.2585 1.09182L12.5797 0.12432Z"
              fill="#7F56D9"
            />
          </svg>
        </span>
        <span class="btn-label">Suggest Instructions from Video</span>
      </button>

      <template v-else-if="hasInstructions">
        <button
          class="text-action-btn"
          :class="{ 'text-action-btn--disabled': disabled }"
          :disabled="disabled"
          @click="handleSetVideoToBeInstructions"
        >
          Set Video to be the Instructions
        </button>
        <StandardButton
          type="magenta"
          variant="outline"
          size="small"
          label="Remove Video Instructions"
          :disabled="disabled"
          @click="handleRemoveVideoInstructions"
        />
      </template>
    </div>

    <div class="microlearning-video-actions-bar-right">
      <StandardButton
        type="magenta"
        variant="outline"
        size="small"
        label="Replace"
        :disabled="disabled"
        @click="handleReplace"
      />
      <StandardButton
        type="red"
        variant="outline"
        size="small"
        label="Delete"
        :disabled="disabled"
        @click="handleDelete"
      />
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import StandardButton from "@components/StandardButton/StandardButton.vue";

const props = defineProps({
  hasInstructions: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  showSuggestInstructionsButton: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits([
  "suggest-instructions",
  "set-video-to-be-instructions",
  "remove-video-instructions",
  "replace",
  "delete",
]);

const isHovered = ref(false);

const handleSuggestInstructions = () => {
  if (!props.disabled) {
    emit("suggest-instructions");
  }
};

const handleSetVideoToBeInstructions = () => {
  if (!props.disabled) {
    emit("set-video-to-be-instructions");
  }
};

const handleRemoveVideoInstructions = () => {
  if (!props.disabled) {
    emit("remove-video-instructions");
  }
};

const handleReplace = () => {
  if (!props.disabled) {
    emit("replace");
  }
};

const handleDelete = () => {
  if (!props.disabled) {
    emit("delete");
  }
};
</script>

<style scoped>
.microlearning-video-actions-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 16px;
}

.microlearning-video-actions-bar-left {
  display: flex;
  align-items: center;
  gap: 8px;
}

.microlearning-video-actions-bar-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.suggest-instructions-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px 8px 8px;
  border-radius: 8px;
  border: 1px solid #7f56d9;
  background-color: #f2edff;
  cursor: url("../assets/cursorArrow.svg"), auto;
  font-family: Inter, sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: #7f56d9;
  transition: background-color 0.15s ease;
}

.suggest-instructions-btn:hover,
.suggest-instructions-btn--hover {
  background-color: #e4dbfc;
  box-shadow: 0px 1px 2px 0px #1018280d;
}

.suggest-instructions-btn:disabled {
  background-color: #e4e7ec;
  border-color: #e4e7ec;
  color: #98a2b3;
  cursor: not-allowed;
}

.suggest-instructions-btn:disabled .sparkle-icon svg path {
  fill: #98a2b3;
}

.iq-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}

.sparkle-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-label {
  white-space: nowrap;
}

.text-action-btn {
  display: flex;
  align-items: center;
  padding: 8px 14px;
  border-radius: 8px;
  border: none;
  background-color: #f2edff;
  cursor: url("../assets/cursorArrow.svg"), auto;
  font-family: Inter, sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: #7f56d9;
  white-space: nowrap;
}

.text-action-btn:hover {
  background-color: #e4dbfc;
}

.text-action-btn--disabled,
.text-action-btn:disabled {
  background-color: #f2edff;
  color: #d6bbfb;
  cursor: not-allowed;
}
</style>
